import { render, staticRenderFns } from "./ChangeRoleComponent.vue?vue&type=template&id=47ffaa87&scoped=true"
import script from "./ChangeRoleComponent.vue?vue&type=script&lang=js"
export * from "./ChangeRoleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ffaa87",
  null
  
)

export default component.exports